__turbopack_context__.v({
  "accordion_answer": "AccordionItem-module-scss-module__Npixxa__accordion_answer",
  "accordion_answer_content": "AccordionItem-module-scss-module__Npixxa__accordion_answer_content",
  "accordion_answer_inner": "AccordionItem-module-scss-module__Npixxa__accordion_answer_inner",
  "accordion_button": "AccordionItem-module-scss-module__Npixxa__accordion_button",
  "accordion_icon": "AccordionItem-module-scss-module__Npixxa__accordion_icon",
  "accordion_item": "AccordionItem-module-scss-module__Npixxa__accordion_item",
  "accordion_note": "AccordionItem-module-scss-module__Npixxa__accordion_note",
  "accordion_text": "AccordionItem-module-scss-module__Npixxa__accordion_text",
  "accordion_title": "AccordionItem-module-scss-module__Npixxa__accordion_title",
  "open": "AccordionItem-module-scss-module__Npixxa__open",
});
